/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespComponents_itemSearch$ref = any;
type SbRespComponents_shippingFilters$ref = any;
type SbRespComponents_user$ref = any;
type SbRespComponents_viewer$ref = any;
type SbSharedHead_itemSearch$ref = any;
type SbSharedRefetchContainer_itemSearch$ref = any;
type SbSharedRefetchContainer_regionalInfo$ref = any;
type SbSharedRefetchContainer_shippingFilters$ref = any;
type SbSharedTrackingContainer_itemSearch$ref = any;
type SbSharedTrackingContainer_user$ref = any;
export type SbRespLayout_viewer$ref = any;
export type SbRespLayout_viewer = {
    readonly itemSearch: {
        readonly pageType: string | null;
        readonly displayUriRef: string | null;
        readonly " $fragmentRefs": SbSharedRefetchContainer_itemSearch$ref & SbSharedTrackingContainer_itemSearch$ref & SbSharedHead_itemSearch$ref & SbRespComponents_itemSearch$ref;
    } | null;
    readonly user?: {
        readonly " $fragmentRefs": SbSharedTrackingContainer_user$ref & SbRespComponents_user$ref;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
        readonly " $fragmentRefs": SbSharedRefetchContainer_regionalInfo$ref;
    } | null> | null;
    readonly shippingFilters?: ReadonlyArray<{
        readonly " $fragmentRefs": SbSharedRefetchContainer_shippingFilters$ref & SbRespComponents_shippingFilters$ref;
    } | null> | null;
    readonly " $fragmentRefs": SbRespComponents_viewer$ref;
    readonly " $refType": SbRespLayout_viewer$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v1 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
};
return {
  "kind": "Fragment",
  "name": "SbRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "hasPersonalizedFilter",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": "0"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "page",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "eligibleAbTest",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "disableForceFacet",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchSb",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemSearch",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "disableForceFacet",
          "variableName": "disableForceFacet"
        },
        {
          "kind": "Variable",
          "name": "eligibleAbTest",
          "variableName": "eligibleAbTest"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "localeOrigin",
          "variableName": "localeOrigin"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        (v0/*: any*/)
      ],
      "concreteType": "ItemSearchQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "pageType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayUriRef",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedRefetchContainer_itemSearch",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedTrackingContainer_itemSearch",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedHead_itemSearch",
          "args": null
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "fetchSb",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_itemSearch",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespComponents_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasPersonalizedFilter",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            (v1/*: any*/)
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_regionalInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shippingFilters",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "concreteType": "ShippingFilterType",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_shippingFilters",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_shippingFilters",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'f283ed29219aafaf237c2098abd8703d';
export default node;
